import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Center } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import { Identity } from "@pdfking/tfunc"

import type { ImpositionNode } from "#internal"

import { CreateGroup } from "../../../shapes/CreateGroup"
import { Intersect } from "./Intersect"

/**
 * What `draw` gives, moved onto the middle of `position` — when no page of
 * `layout` touches `position`, as for the cut marks; nothing otherwise.
 * `draw` gets `position` centred on the origin and draws about it, so a mark
 * drawn on its middle goes in as it is. `from_sheet` reads the layout in the
 * frame `position` is in, as for {@link Intersect}.
 */
export const PlotWithSpace = (
  layout: ImpositionNode,
  position: SpatialRectangle<Distance>,
  draw: (box: SpatialRectangle<Distance>) => PageShape[],
  from_sheet: (box: SpatialRectangle<Distance>) => SpatialRectangle<Distance> = Identity
): PageShape[] => {
  if (Intersect(layout, position, from_sheet)) return []
  const { width, height } = position
  const box = {
    x: (-width / 2) as Distance,
    y: (-height / 2) as Distance,
    width,
    height,
  }
  return CreateGroup(draw(box), { translate: Center(position) })
}
